import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { PickListModule } from 'primeng/picklist';
import { OrderListModule } from 'primeng/orderlist';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { TabViewModule } from 'primeng/tabview';
import { DataViewModule } from 'primeng/dataview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { SliderModule } from 'primeng/slider';
import { InputMaskModule } from 'primeng/inputmask';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ColorPickerModule } from 'primeng/colorpicker';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ListboxModule } from 'primeng/listbox';
import { ChartModule } from 'primeng/chart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import {TreeModule} from 'primeng/tree';
import {TreeNode} from 'primeng/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DragDropModule } from 'primeng/dragdrop';
import { SafePipe } from '../pipe.url';
import { LoaderComponent } from '@pages/_components/loader/loader.component';
import { WaitingComponent } from '@pages/_components/waiting/waiting.component';
import { LoaderDialogComponent } from '@pages/_components/loader-dialog/loader-dialog.component';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';

import { CommentairesComponent } from './commentaires';
import { TracesComponent } from './traces';
import { ThumbsComponent } from './thumbs';
import { LinesGridComponent } from './linesgrid';
import { LineGridComponent } from './linegrid';
import { DocumentDetailComponent } from './documentdetail';
import { DocumentDetailComponentGrid } from './documentdetailgrid';
import { DocumentDetailVersionComponent } from './documentdetailversion';
import { FieldToolsComponent } from './fieldtools';
import { BtnToolsComponent } from './btntools';
import { BtnToolComponent } from './btntool';
import { ReqDetCriteriaComponent } from './reqdetcriteria';
import { ReqEntCriteriaComponent } from './reqentcriteria';
import { DmFieldsetHeaderComponent } from './dm-fieldset-header';
import { InputValueComponent } from './inputvalue';
import { InputIndexComponent } from './inputindex';
import { DisplayValueComponent } from './displayvalue';
import { InfosMailComponent } from './infosmail';
import { DisplayResultComponent } from './displayresult';
import { DisplayResultGridComponent } from './displayresultgrid';
import { FieldsetModule } from 'primeng/fieldset';
import { BskFiltersComponent } from './bskfilters';
import { BskFilterComponent } from './bskfilter';
import { ExportDocsComponent } from './exportdocs';
import { StatDocsComponent } from './statdocs';
import { ActionsDocComponent } from './actionsdoc';
import { DateCompatPipe } from '@core/_utils/date-compat.pipe';
import { DateLenghtPipe } from '@core/_utils/date-compat.pipe';
import { TruncatePipe } from '@core/_utils/truncate.pipe';
import { AddFileComponent } from './addfile';
import { NgxUploadModule } from '@wkoza/ngx-upload';
import { BasketComponent } from './basket';
import { DockMailComponent } from './dockmail';
import { ResDetIndexComponent } from './resdetindex';
import { AttachedFileComponent } from './attachedfile';
import { TreeSearchRequestComponent } from './treesearchrequest';
import { MoveDocsComponent } from './movedocs';
import { TransBskComponent } from './transbsk';
import { SendDocsMailComponent } from './senddocsmail';
import { VersionDocComponent } from './versiondoc';
import { VersionListComponent } from './versionlist';
import { BasketFilterComponent } from './basketfilter';
import { AddBaseFileComponent } from './addbasefile';
import { DeleteDocsComponent } from './deletedocs';
import { DashBoardStatComponent } from './dashboardstat';
import { DashLastDocComponent } from './dashlastdoc';
import { DashLastActionDocComponent } from './dashlastactiondoc';
import { DashBskLoadComponent } from './dashbskload';
import { DashBskOldComponent } from './dashbskold';
import { DashContentComponent } from './dashcontent';
import { DashLastRequestComponent } from './dashlastrequest';
import { ChangeDocsComponent } from './changedocs';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { FilterDocsComponent } from './filterdocs';
import { VisibilityComponent } from './visibility';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InplaceModule } from 'primeng/inplace';
import { DividerModule } from 'primeng/divider';
import { BasketParamComponent } from './basket-param';
import { TranslateModule } from '@ngx-translate/core';
import { GridsterModule } from 'angular-gridster2';
import { PasswordModule } from 'primeng/password';
import { PageViewDoc } from './page-viewdoc/page-viewdoc.component';
import { BlockUIModule } from 'primeng/blockui';
import {BadgeModule} from "primeng/badge";
import {KnobModule} from "primeng/knob";
import { TagModule } from 'primeng/tag';
import { CardModule  } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { BasketNewDocComponent } from './basketnewdoc';
import {PdfPreviewComponent} from "./pdf-preview/pdf-preview.component";
import { AtfViewComponent } from './atf-view/atf-view.component';
import { InternalModule } from './internal.module';
import { CompositionPdfComponent} from "@documalis/composition-pdf/composition-pdf.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        ButtonModule,
        ConfirmDialogModule,
        BreadcrumbModule,
        InputTextModule,
        InputTextareaModule,
        InputNumberModule,
        RadioButtonModule,
        CalendarModule,
        PickListModule,
        OrderListModule,
        DialogModule,
        DropdownModule,
        PanelModule,
        FileUploadModule,
        // TooltipModule,
        AutoCompleteModule,
        TabViewModule,
        DataViewModule,
        MultiSelectModule,
        SliderModule,
        InputMaskModule,
        ToggleButtonModule,
        SplitButtonModule,
        TableModule,
        FieldsetModule,
        ContextMenuModule,
        TriStateCheckboxModule,
        NgxExtendedPdfViewerModule,
        NgxUploadModule.forRoot(),
        ListboxModule,
        ChartModule,
        OverlayPanelModule,
        ProgressSpinnerModule,
        TreeModule,
        DragDropModule,
        InputSwitchModule,
        InplaceModule,
        DividerModule,
        ColorPickerModule,
        TranslateModule,
        GridsterModule,
        PasswordModule,
        BlockUIModule,
        BadgeModule,
        KnobModule,
        TagModule,
        CardModule,
        SkeletonModule,
        InternalModule,
        CompositionPdfComponent,
        NgOptimizedImage
    ],
    declarations: [
        SafePipe,
        LoaderComponent,
        LoaderDialogComponent,
        WaitingComponent,
        TracesComponent,
        ThumbsComponent,
        LinesGridComponent,
        LineGridComponent,
        DocumentDetailComponent,
        DocumentDetailComponentGrid,
        DocumentDetailVersionComponent,
        // FieldToolsComponent,
        BtnToolsComponent,
        BtnToolComponent,
        ReqDetCriteriaComponent,
        ReqEntCriteriaComponent,
        DmFieldsetHeaderComponent,
        CommentairesComponent,
        InputValueComponent,
        InputIndexComponent,
        DisplayValueComponent,
        InfosMailComponent,
        BskFilterComponent,
        BskFiltersComponent,
        DisplayResultComponent,
        DisplayResultGridComponent,
        ExportDocsComponent,
        StatDocsComponent,
        ActionsDocComponent,
        DateCompatPipe,
        DateLenghtPipe,
        TruncatePipe,
        AddFileComponent,
        BasketComponent,
        DockMailComponent,
        ItemConfirmComponent,
        ResDetIndexComponent,
        AttachedFileComponent,
        TreeSearchRequestComponent,
        MoveDocsComponent,
        TransBskComponent,
        SendDocsMailComponent,
        VersionDocComponent,
        VersionListComponent,
        BasketFilterComponent,
        BasketNewDocComponent,
        AddBaseFileComponent,
        DeleteDocsComponent,
        DashBoardStatComponent,
        DashLastDocComponent,
        DashLastActionDocComponent,
        DashBskLoadComponent,
        DashBskOldComponent,
        DashContentComponent,
        DashLastRequestComponent,
        ChangeDocsComponent,
        AutofocusDirective,
        FilterDocsComponent,
        // VisibilityComponent,
        BasketParamComponent,
        PageViewDoc,
        LoaderComponent,
        PdfPreviewComponent,
        AtfViewComponent
    ],
    exports: [
        CommonModule,
        SharedModule,
        FormsModule,
        CheckboxModule,
        ButtonModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        BreadcrumbModule,
        InputTextModule,
        InputTextareaModule,
        RadioButtonModule,
        CalendarModule,
        PickListModule,
        OrderListModule,
        DialogModule,
        DropdownModule,
        PanelModule,
        FileUploadModule,
        SafePipe,
        // TooltipModule,
        AutoCompleteModule,
        MultiSelectModule,
        SliderModule,
        InputMaskModule,
        ToggleButtonModule,
        SplitButtonModule,
        TabViewModule,
        DataViewModule,
        TableModule,
        TriStateCheckboxModule,
        ListboxModule,
        ChartModule,
        OverlayPanelModule,
        ColorPickerModule,
        TagModule,
        CardModule,
        LoaderComponent,
        LoaderDialogComponent,
        WaitingComponent,
        TracesComponent,
        ThumbsComponent,
        LinesGridComponent,
        LineGridComponent,
        DocumentDetailComponent,
        DocumentDetailComponentGrid,
        DocumentDetailVersionComponent,
        // FieldToolsComponent,
        BtnToolsComponent,
        BtnToolComponent,
        ReqDetCriteriaComponent,
        ReqEntCriteriaComponent,
        DmFieldsetHeaderComponent,
        CommentairesComponent,
        InputValueComponent,
        InputIndexComponent,
        DisplayValueComponent,
        InfosMailComponent,
        BskFilterComponent,
        BskFiltersComponent,
        DisplayResultComponent,
        ExportDocsComponent,
        StatDocsComponent,
        ActionsDocComponent,
        DateCompatPipe,
        DateLenghtPipe,
        TruncatePipe,
        AddFileComponent,
        BasketComponent,
        DockMailComponent,
        ItemConfirmComponent,
        ResDetIndexComponent,
        AttachedFileComponent,
        TreeSearchRequestComponent,
        MoveDocsComponent,
        TransBskComponent,
        SendDocsMailComponent,
        VersionDocComponent,
        VersionListComponent,
        BasketFilterComponent,
        BasketNewDocComponent,
        AddBaseFileComponent,
        DeleteDocsComponent,
        DashBoardStatComponent,
        DashLastDocComponent,
        DashLastActionDocComponent,
        DashBskLoadComponent,
        DashBskOldComponent,
        DashContentComponent,
        DashLastRequestComponent,
        ChangeDocsComponent,
        AutofocusDirective,
        ProgressSpinnerModule,
        TreeModule,
        DragDropModule,
        FilterDocsComponent,
        // VisibilityComponent,
        BasketParamComponent,
        PageViewDoc,
        PdfPreviewComponent,
        AtfViewComponent,
        InternalModule
    ],
})
export class SharedDocumalisModule {}
